import { render, staticRenderFns } from "./TemplatePicker.vue?vue&type=template&id=4a1dc93d&scoped=true"
import script from "./TemplatePicker.vue?vue&type=script&lang=js"
export * from "./TemplatePicker.vue?vue&type=script&lang=js"
import style0 from "./TemplatePicker.vue?vue&type=style&index=0&id=4a1dc93d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1dc93d",
  null
  
)

export default component.exports